module.exports = __webpack_public_path__ + "img/img-61.c31a74be.png";